<script>
import Languages from "../lang/lang";


export default {
  name: 'SectionAccount',
  data() {
    let user = window['xive']['userData'].user;
    return {
      initialName: (user.name + (user.lastName != null ? ' ' + user.lastName : '')).trim(),
      name: (user.name + (user.lastName != null ? ' ' + user.lastName : '')).trim(),
      savingName: false,
      savedName: false,
      settings: null,
      processingOAuth: false,
      index: null,
      change: false,
      twitterBotToken: "",
      generatingToken: false,

      getSettings() {
        this.dataLoading = true;
        fetch(
            window['API_URL'] + '/api/v4/settings/auth',
            {
              headers: {
                'X-Auth-Token': window['xive']['getCookie']('x-auth-token'),
              }
            }).then(res => res.json())
        .then(res => {
          this.settings = res.data;
          this.dataLoading = false;
        });

        fetch(
            window['API_URL'] + '/api/v4/settings/telegram/token',
            {
              headers: {
                'X-Auth-Token': window['xive']['getCookie']('x-auth-token'),
              }
            }).then(res => res.json())
        .then(res => {
          this.twitterBotToken = res.data.value;
        });
      },
      saveName() {
        this.savingName = true;
        this.savedName = false;
        fetch(window['API_URL'] + '/api/v4/settings/name', {
          method: 'POST',
          body: this.name,
          headers: {
            'X-Auth-Token': window['xive']['getCookie']('x-auth-token'),
          }
        }).then(res => res.json())
            .then(res => {
              this.initialName = res.data.value;
              this.savingName = false;
              this.savedName = true;
            });
      },

      cancel() {
        this.name = this.initialName;
      },

      generateTwitterToken() {
        this.generatingToken = true;
        fetch(window['API_URL'] + '/api/v4/settings/telegram/token/generate', {
          method: 'GET',
          headers: {
            'X-Auth-Token': window['xive']['getCookie']('x-auth-token'),
          }
        }).then(res => res.json())
            .then(res => {
              this.twitterBotToken = res.data.value;
              this.generatingToken = false;
            });
      },
      deleteTwitterToken() {
        this.generatingToken = true;
        fetch(window['API_URL'] + '/api/v4/settings/telegram/token', {
          method: 'DELETE',
          headers: {
            'X-Auth-Token': window['xive']['getCookie']('x-auth-token'),
          }
        }).then(res => res.json())
            .then(res => {
              this.twitterBotToken = res.data.value;
              this.generatingToken = false;
            });
      },

      password: "",
      passwordShown: false,
      passwordError: null,
      newPassword: "",
      newPasswordShown: false,
      newPasswordError: null,
      repeatPassword: "",
      repeatPasswordShown: false,
      savingPassword: false,
      savedPassword: false,
      removePassword: "",
      removePasswordError: null,
      removePasswordShown: false,
      removingPassword: false,
      setChangePassword() {
        if (this.change) {
          this.change = false
        } else {
          this.change = true
        }
      },
      savePassword() {
        this.passwordError = null;
        this.newPasswordError = null;
        if (this.newPassword.length < 6) {
          this.newPasswordError = 'password-length';
          this.newPassword = '';
          return;
        }

        this.savingPassword = true;
        this.savedPassword = false;

        fetch(window['API_URL'] + '/api/v4/auth/change-password', {
          method: 'POST',
          headers: {
            'X-Auth-Token': window['xive']['getCookie']('x-auth-token'),
            'Content-Type': 'application/json;charset=utf-8'
          },
          body: JSON.stringify({
            newPassword: this.newPassword,
            oldPassword: this.password
          })
        }).then(res => res.json())
            .then(res => {
              this.savingPassword = false;
              if (res.data === true) {
                this.password = "";
                this.newPassword = "";
                this.repeatPassword = "";
                this.savedPassword = true;

                if (!this.settings.isPasswordSet) {
                  this.change = false;
                }
                this.settings.isPasswordSet = true;
              } else if (res.error === 'wrong_user_password') {
                this.passwordError = res.error;
                this.password = '';
              }
            });
      },
      showRemovePassword() {
        this.removePasswordError = null;
        this.removePassword = '';
        this.removingPassword = false;
        this.removePasswordShown = true;
      },
      cancelRemovePassword() {
        this.removePasswordShown = false;
      },
      saveRemovePassword() {
        this.removingPassword = true;
        fetch(window['API_URL'] + '/api/v4/settings/auth/remove-password', {
          method: 'POST',
          headers: {
            'X-Auth-Token': window['xive']['getCookie']('x-auth-token'),
          },
          body: this.removePassword
        }).then(res => res.json())
            .then(res => {
              if (res.status) {
                this.settings = res.data;
                this.removePasswordShown = false;
              } else {
                this.removePasswordError = res.error;
                this.removePassword = '';
                this.removingPassword = false;
              }
            });
      },
      setProcessingOAuth(row, process){
        this.index = this.settings.providers.findIndex(x => x.oauthProvider === row);
        this.settings.providers[this.index].processingOAuth = process;
      },
      oAuthDisableClick(row) {
        this.setProcessingOAuth(row, true);
        fetch(window['API_URL'] + '/api/v4/settings/auth/oauth/' + row, {
          method: 'DELETE',
          headers: {
            'X-Auth-Token': window['xive']['getCookie']('x-auth-token'),
          }
        }).then(res => res.json())
        .then(res => {
          this.settings = res.data;
          this.setProcessingOAuth(row, false);
        });
      },
      oAuthEnableClick(row) {
        this.setProcessingOAuth(row, true);
        fetch(window['API_URL'] + '/api/v4/settings/auth/oauth/' + row, {
          method: 'POST',
          body: null,
          headers: {
            'X-Auth-Token': window['xive']['getCookie']('x-auth-token'),
          }
        }).then(res => res.json())
        .then(res => {
          this.settings = res.data;
          this.setProcessingOAuth(row, false);
        });
      },
      getProviderName(providerCode) {
        if (providerCode == 'google') {
          return 'Google';
        } else if (providerCode == 'facebook') {
          return 'Facebook';
        } else if (providerCode == 'twitter') {
          return 'Twitter';
        } return null;
      }
    }
  },
  mounted() {
    this.getSettings();
  },
  computed: {
    lang() {
      return Languages.texts('account');
    },
    currentLang() {
      return window['CURRENT_LANGUAGE'];
    },
    generalLang() {
      return Languages.texts('general');
    },
    dataPasswordShown() {
      return this.passwordShown ? "1" : "0"
    },
    dataPasswordType() {
      return this.passwordShown ? "text" : "password"
    },
    dataNewPasswordShown() {
      return this.newPasswordShown ? "1" : "0"
    },
    dataNewPasswordType() {
      return this.newPasswordShown ? "text" : "password"
    },
    dataRepeatPasswordShown() {
      return this.repeatPasswordShown ? "1" : "0"
    },
    dataRepeatPasswordType() {
      return this.repeatPasswordShown ? "text" : "password"
    },
    passwordPlaceholderText() {
      if (this.passwordError === 'wrong_user_password') {
        return this.lang['wrongPassword'];
      }
      return this.lang['oldPassword'];
    },
    newPasswordPlaceholderText() {
      if (this.newPasswordError === 'password-length') {
        return this.lang['min6chars'];
      }
      return this.lang['newPassword'];
    },
    changePasswordOk() {
      return (this.password.trim() !== '' || !this.settings.isPasswordSet) &&
          this.newPassword.trim() !== '' &&
          this.repeatPassword === this.newPassword;
    },
    removePasswordPlaceholderText() {
      if (this.removePasswordError === 'wrong_user_password') {
        return this.lang['wrongPassword'];
      }
      return this.lang['enterCurrentPassword'];
    },
  }
}
</script>

<template>
  <div>
    <div class="back-link">
      <router-link to="/">{{ generalLang['back'] }}</router-link>
    </div>
    <div class="section-account">
      <div class="block-title">
        {{ lang['title'] }}
      </div>
      <div class="blocks">
        <div class="settings-block">

          <div class="form">
            <input type="text" v-model="name" :placeholder="lang['enterName']" />
            <div class="btn btn-gray-border" v-if="name === initialName || name.trim() === '' || savingName">
              <template v-if="!savingName">
                <template v-if="!savedName">
                  {{ lang['saveChanges'] }}
                </template>
                <template v-if="savedName">
                  {{ lang['changesSaved'] }}
                </template>
              </template>
              <template v-if="savingName">
                {{ lang['saving'] }}
              </template>
            </div>
            <div class="buttons">
              <div class="btn btn-gold"
                   v-if="name !== initialName && name.trim() !== '' && !savingName" @click="saveName()">
                <div>{{ lang['saveChanges'] }}</div>
              </div>
              <div class="btn btn-simple"
                   v-if="name !== initialName && name.trim() !== '' && !savingName" @click="cancel()">
                <div>{{ lang['cancelChanges'] }}</div>
              </div>
            </div>
          </div>

          <div class="form" v-if="settings">
            <div>
              <div class="block-title">
                {{ lang['loginMethods'] }}:
              </div>
              <div class="login-methods" :data-enabled="settings.isPasswordSet ? '1' : '0'">
                <div>
                  1. {{ lang['viaPassword'] }}
                </div>
                <div class="action password-action">
                  <div v-if="settings.isPasswordSet && settings.providers != null" class="two-buttons">
                    <div class="login-method-button" data-method="edit"
                         :style="change || removePasswordShown ? 'visibility: hidden' : ''"
                         @click = "setChangePassword()"></div>
                    <div class="login-method-button" data-method="remove"
                         :style="change ? 'visibility: hidden' : ''"
                         @click="showRemovePassword()"
                         v-if="settings.isOAuthAllowed && !removePasswordShown"></div>
                  </div>
                  <div class="login-method-button" data-method="edit"
                       v-if="!settings.isPasswordSet"
                       @click = "setChangePassword()"></div>
                </div>
              </div>
            </div>

            <div class="form" v-if="change">
              <div class="password-group" :data-password-shown="dataPasswordShown" v-if="settings.isPasswordSet">
                <input :type="dataPasswordType"
                       :class="passwordError != null ? 'error' : ''"
                       v-model="password" :placeholder="passwordPlaceholderText" />
                <div class="eye" @click="passwordShown = !passwordShown"></div>
              </div>

              <div class="password-group" :data-password-shown="dataNewPasswordShown">
                <input :type="dataNewPasswordType"
                       :class="newPasswordError && newPassword.length === 0 ? 'error' : ''"
                       v-model="newPassword"
                       :placeholder="newPasswordPlaceholderText"/>
                <div class="eye" @click="newPasswordShown = !newPasswordShown"></div>
              </div>

              <div class="password-group" :data-password-shown="dataRepeatPasswordShown">
                <input :type="dataRepeatPasswordType" v-model="repeatPassword" :placeholder="lang['retypeNewPassword']" />
                <div class="eye" @click="repeatPasswordShown = !repeatPasswordShown"></div>
              </div>

              <div class="buttons">
                <div class="btn btn-gold" @click="savePassword()"
                     v-if="changePasswordOk && !savingPassword">
                  <div>{{ lang['saveChanges'] }}</div>
                </div>

                <div class="btn btn-gray-border"
                     v-if="!changePasswordOk || savingPassword">
                  <template v-if="!savingPassword">
                    <template v-if="!savedPassword">
                      {{ lang['saveChanges'] }}
                    </template>
                    <template v-if="savedPassword">
                      {{ lang['passwordSaved'] }}
                    </template>
                  </template>
                  <template v-if="savingPassword">
                    {{ lang['saving'] }}
                  </template>
                </div>
                <div class="btn btn-simple"  v-if="change" @click = "setChangePassword()">
                  {{ lang['cancel'] }}
                </div>
              </div>
            </div>

            <div class="form" v-if="removePasswordShown">
              <div class="password-group" :data-password-shown="dataPasswordShown">
                <input :type="dataPasswordType"
                       :class="removePasswordError != null ? 'error' : ''"
                       v-model="removePassword" :placeholder="removePasswordPlaceholderText" />
                <div class="eye" @click="passwordShown = !passwordShown"></div>
              </div>
              <div>
                <small>{{ lang['removeWarning'] }}</small>
              </div>

              <div class="buttons">
                <div class="btn btn-gray-border"
                     v-if="removePassword.trim() === '' && !removingPassword">
                  {{ lang['removePassword'] }}
                </div>
                <div class="btn btn-gold" @click="saveRemovePassword()"
                     v-if="removePassword.trim() !== '' && !removingPassword">
                  {{ lang['removePassword'] }}
                </div>
                <div class="btn btn-gray-border"
                     v-if="removingPassword">
                  {{ lang['removingPassword'] }}
                </div>
                <div class="btn btn-simple" v-if="!removingPassword"
                     @click="cancelRemovePassword()">
                  {{ lang['cancel'] }}
                </div>
              </div>
            </div>

            <div v-if="settings.providers != null" >
              <div  v-for="row of settings.providers">
                <div class="login-methods" :data-enabled="row.isOAuthAllowed ? '1' : '0'">
                  <div>
                    2. {{getProviderName(row.oauthProvider)}}<br/>
                    <small >
                      {{ lang['viaSocial'] }} {{getProviderName(row.oauthProvider)}}
                    </small>
                  </div>
                  <div class="action">
                    <div v-if="row.isOAuthAllowed && settings.isPasswordSet">
                      <div class="login-method-button" data-method="disable"
                           :data-processing="row.processingOAuth ? '1' : ''"
                         @click="oAuthDisableClick(row.oauthProvider)">
                        <!--<div  v-if="row.processingOAuth">
                          {{ lang['saving'] }}
                        </div>
                        <div v-if="!row.processingOAuth">
                          {{ lang['disable'] }}
                        </div>-->
                      </div>
                    </div>
                    <div  v-if="!row.isOAuthAllowed">
                      <a class="login-method-button" data-method="enable"
                         :data-processing="row.processingOAuth ? '1' : ''"
                         @click="oAuthEnableClick(row.oauthProvider)">
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="form">
            <div class="component-title">
              {{ lang['twitterTokenAccess'] }}:
            </div>
            <input type="text" v-model="twitterBotToken" :readonly="true"/>
            <div class="buttons">
              <div class="btn btn-gold" @click="generateTwitterToken()">
                <div>{{ lang['generateToken'] }}</div>
              </div>
              <div class="btn btn-simple" @click="deleteTwitterToken()">
                <div>{{ lang['deleteToken'] }}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="links-block">
          <div class="link-block">
            <div>{{ lang['deleteAccount'] }}</div>
            <a :href="'/' + currentLang + '/contacts'" class="btn btn-gold">{{ lang['contactSupport'] }}</a>
          </div>
          <div class="link-block">
            <div>{{ lang['questions'] }}</div>
            <a :href="'/' + currentLang + '/contacts'" class="btn btn-gold">{{ lang['getHelp'] }}</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>